import { registerBrick, BrickContext } from 'olympe';
import { ReactBrick, useProperty } from '@olympeio/core';
// prettier-ignore
import { IconButton, Typography, Button, ThemeProvider, DialogTitle, DialogContent, DialogActions, Dialog } from '@mui/material';
import Icon from '@mui/material/Icon';
import CloseIcon from '@mui/icons-material/Close';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import React from 'react';
import { globalTheme } from '../shared/_theme.jsx';
import './blocked_parked.css';
import { formatApiDate } from '../../utils/_helpers.js';

const editableAgentTypes = ['US', 'S']; // US = Users, S = Position

export default class ApproversForResponsibility extends ReactBrick {
    /**
     * @override
     * @protected
     * @param {!BrickContext} $
     * @param {!Array<*>} properties
     * @returns {Element}
     */

    static getReactComponent($) {
        return (props) => {
            // Get input props
            const approvers = useProperty($, 'Approvers');
            const canEdit = useProperty($, 'Can edit');

            // edit element handler
            const onEditElement = (index) => {
                $.set('Selected approver', approvers[index]);
                $.trigger('On Edit');
            };

            // remove element handler
            const onRemoveHandler = (index) => {
                $.set('Selected approver', approvers[index]);
                setOpenDelete(true);
            };

            // Formatters
            const statusFormatter = (value) => {
                return (
                    <div style={{ display: 'flex', alignItems: 'flex-start', gap: 8 }}>
                        <Icon
                            style={{
                                color: value === 'X' ? 'green' : 'red',
                                fontSize: '20px',
                                display: 'inline-block',
                            }}
                        >
                            circle
                        </Icon>
                        <Typography component="span">{value === 'X' ? 'Valid' : 'Not Valid'}</Typography>
                    </div>
                );
            };

            // Confirm Dialog state
            const [openDelete, setOpenDelete] = React.useState(false);
            const closeConfirmDelete = () => {
                setOpenDelete(false);
            };
            const confirmDelete = () => {
                setOpenDelete(false);
                $.trigger('On Delete');
            };

            // handle auto-height for non-editable version
            const wrapper = React.useRef();
            const resizeObserver = new ResizeObserver((entries) => {
                const entry = entries.at(0);
                $.set('Height', entry.contentRect.height);
            });
            React.useEffect(() => {
                resizeObserver.observe(wrapper.current);
                return () => wrapper.current && resizeObserver.unobserve(wrapper.current);
            }, []);
            React.useEffect(() => {
                updateHeight();
            }, [approvers]);
            let updateHeightTimeout;
            const updateHeight = () => {
                clearTimeout(updateHeightTimeout);
                updateHeightTimeout = setTimeout(() => {
                    wrapper.current && $.set('Height', wrapper.current.offsetHeight);
                }, 150);
            };

            return (
                <ThemeProvider theme={globalTheme}>
                    <div className={`responsibility-agents`} ref={wrapper}>
                        <div className="responsibility-agents-grid">
                            <div className="responsibility-agents-headers">
                                <Typography>Name / Position</Typography>
                                <Typography>Assigned as Of</Typography>
                                <Typography>Assigned Until</Typography>
                                <Typography>Status</Typography>
                                <Typography>Comments</Typography>
                                <div></div>
                            </div>

                            {Array.isArray(approvers) ? (
                                approvers.map((approver, index) => (
                                    <div className="responsibility-agents-row" key={index}>
                                        <Typography>
                                            {approver.AgentName} ({approver.AgentId})
                                        </Typography>
                                        <Typography>{formatApiDate(approver.AgentStartDate)}</Typography>
                                        <Typography>{formatApiDate(approver.AgentEndDate)}</Typography>
                                        {statusFormatter(approver.AgentFlag)}
                                        <Typography>{approver.Comments}</Typography>
                                        <div className="responsibility-agents-buttons">
                                            {canEdit && (
                                                <>
                                                    {editableAgentTypes.includes(approver.AgentType) && (
                                                        <IconButton onClick={() => onEditElement(index)}>
                                                            <EditIcon sx={{ fontSize: '16px' }} />
                                                        </IconButton>
                                                    )}
                                                    <IconButton onClick={() => onRemoveHandler(index)}>
                                                        <DeleteIcon sx={{ fontSize: '16px' }} />
                                                    </IconButton>
                                                </>
                                            )}
                                        </div>
                                    </div>
                                ))
                            ) : (
                                <Typography>Loading ...</Typography>
                            )}

                            {Array.isArray(approvers) && approvers.length === 0 ? (
                                <Typography>No agent found</Typography>
                            ) : null}
                        </div>
                    </div>
                    <Dialog open={openDelete}>
                        <DialogTitle>
                            Delete Agent
                            <IconButton
                                aria-label="close"
                                onClick={closeConfirmDelete}
                                sx={{
                                    position: 'absolute',
                                    right: 10,
                                    top: 10,
                                    color: (theme) => theme.palette.primary.contrastText,
                                }}
                            >
                                <CloseIcon />
                            </IconButton>
                        </DialogTitle>
                        <DialogContent>
                            <Typography sx={{ padding: '20px' }}>Are you sure to delete the Agent ?</Typography>
                        </DialogContent>
                        <DialogActions>
                            <Button variant="text" onClick={closeConfirmDelete}>
                                Cancel
                            </Button>
                            <Button variant="contained" onClick={confirmDelete}>
                                Delete
                            </Button>
                        </DialogActions>
                    </Dialog>
                </ThemeProvider>
            );
        };
    }
}

registerBrick('018b1317a4d164a42156', ApproversForResponsibility);
